import { render, staticRenderFns } from "./additional-invoice.vue?vue&type=template&id=b44e775e&"
import script from "./additional-invoice.vue?vue&type=script&lang=js&"
export * from "./additional-invoice.vue?vue&type=script&lang=js&"
import style0 from "./additional-invoice.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports